import { render, staticRenderFns } from "./adminDataUpdate.vue?vue&type=template&id=a4067f66&"
import script from "./adminDataUpdate.vue?vue&type=script&lang=js&"
export * from "./adminDataUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports